import React, { createContext, useState } from "react";
import PaymentPageLoader from "../components/PaymentPageLoader/PaymentPageLoader";

export const PaymentPageLoaderContext = createContext({});

function PaymentPageLoaderProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  return (
    <>
      <PaymentPageLoaderContext.Provider value={{ setFullPaymentLoading: setLoading, setPaymentStatus: setStatus }}>
        {children}
        {loading && <PaymentPageLoader value={status}/>}
      </PaymentPageLoaderContext.Provider>
    </>
  );
}

export default PaymentPageLoaderProvider;
